var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "revision-container p-2" },
    [
      _c("p", { staticClass: "ms-2 fw-bold" }, [_vm._v("ヒストリー")]),
      _vm._v(" "),
      _vm.currentExamRevision
        ? _c(
            "button",
            {
              staticClass:
                "btn btn-sm btn-outline-success revision-btn me-2 mb-2",
              attrs: { type: "button" },
              on: { click: _vm.setExamRevision },
            },
            [_vm._v("\n    このリビジョンに戻す\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-expansion-panels",
        _vm._l(_vm.examRevisionGroups, function (examRevisionGroup, i) {
          return _c(
            "v-expansion-panel",
            { key: i },
            [
              _c("v-expansion-panel-header", [
                _c("p", { staticClass: "text-secondary" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(examRevisionGroup.date) +
                      "(" +
                      _vm._s(examRevisionGroup.examRevisions.length) +
                      "回)\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("v-expansion-panel-content", [
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  _vm._l(
                    examRevisionGroup.examRevisions,
                    function (examRevision, j) {
                      return _c("RevisionItemComponent", {
                        key: j,
                        attrs: { examRevision: examRevision },
                      })
                    }
                  ),
                  1
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }